export default {
      id: "ic-plan-seniors-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-seniors-usage",
      toString: function () {
        return this.url;
      }
    }